import classNames from 'classnames';
import React, { FC } from 'react';
import { Typography } from '../Typography';
import styles from './PromoCard.module.scss';

type PromoCardTitleProps = {
	size?: 'md' | 'lg';
};

export const PromoCardTitle: FC<PromoCardTitleProps> = ({ size, children }) => {
	return (
		<Typography
			as="p"
			variant={size === 'lg' ? 'h3' : size === 'md' ? 'h4' : 'subheadline'}
			className={classNames(styles.promoCardTitle, size === 'lg' ? 'mb-2 mb-xl-4' : '')}
		>
			{children}
		</Typography>
	);
};
